
































































































































import { Component, Vue } from "vue-property-decorator";
import InspectList from "@/page/user/InspectList.vue";
import { UserService } from "@/service/UserService";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";

@Component({
  components: {
  }
})
export default class QuickInspectListComponent extends InspectList {

  addClass: any = "top-bar__override";

  getSeibi() {
    this.$emit("onUpdateInspectList");
  }

  showNotKouchin(item: any) {
    return (item.showNotKouchin == -1) ? "見積もり中" : "0円";
  }

  addWork() {
    if (this.manualBuhinNm) {
      const manualSeibiList: any = [{
        seibiNm: this.manualBuhinNm,
        /** 2023-10-19 invoice [START] */
        buhinEditTotalZk: this.manualBuhinKn,
        /** 2023-10-19 invoice [END] */
        buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
        kousuu: 0,
        manualBuhinList: []
      }];
      const data: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        sknInspectType: INSPECT_TYPE.USER_MANUAL,
        manualSeibiList: manualSeibiList,
        modeQuick: 1
      };
      this.saveManualAk5(data);
      this.manualBuhinNm = "";
      /** 2023-10-19 invoice [START] */
      this.manualBuhinKn = null;
      /** 2023-10-19 invoice [END] */
    }
    this.$emit("onUpdateInspectList");
  }

}
